var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a-button',_vm._b({staticClass:"p-3 flex justify-center items-center",class:_vm.variant,on:{"click":_vm.onClick}},'a-button',_vm.$attrs,false),[_vm._t("default")],2),_c('LmConfirmationModal',{ref:`button-confirmation-modal-${_vm._uid}`})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }